// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationFreeCashWithdrawalPath = 'M40 12c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5 5-2.243 5-5zm7 0c0 6.617-5.383 12-12 12s-12-5.383-12-12S28.383 0 35 0s12 5.383 12 12zm25.5 63H87V65H72.5c-1.93 0-3.5 1.57-3.5 3.5v3c0 1.93 1.57 3.5 3.5 3.5zM23 91h59v-9h-9.5C66.71 82 62 77.29 62 71.5v-3C62 62.71 66.71 58 72.5 58H82v-8H23c-1.412 0-2.758-.277-4-.764V87c0 2.206 1.794 4 4 4zm28.081-56H23c-2.206 0-4 1.794-4 4s1.794 4 4 4h52v-8h-6.081c-2.198 2.448-5.377 4-8.919 4-3.542 0-6.721-1.552-8.919-4zM65 27c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5 5-2.243 5-5zm24 31h5v24h-5v16H23c-6.065 0-11-4.935-11-11V39.583h.029a10.066 10.066 0 00-.012-.206c-.009-.125-.017-.25-.017-.377 0-6.065 4.935-11 11-11h25.051A11.827 11.827 0 0148 27c0-6.617 5.383-12 12-12s12 5.383 12 12c0 .337-.023.669-.051 1H82v15h7v15z';
var IllustrationFreeCashWithdrawal = baseIllustration('IllustrationFreeCashWithdrawal', {
  getPath: () => IllustrationFreeCashWithdrawalPath
}, 'ColoredIllustrationFreeCashWithdrawal');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationFreeCashWithdrawal;
//# sourceMappingURL=index.js.map